import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import SidebarPage from '../sidebar'
import DeveloperPageProfilepage from './developerprofiledetails'

export default function ProfileManagement() {
  const navigate = useNavigate()
  const [isLargeScreen, setIsLargeScreen] = useState(() => window.innerWidth >= 1000)
  const [username, setUsername] = useState('')

  useEffect(() => {
    const token = sessionStorage.getItem('token')
    if (!token) {
      navigate('/adminlogin')
    }
  }, [navigate])

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1000)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedUsername = localStorage.getItem('username')
      setUsername(storedUsername || '')
    }
  }, [])

  const largeContainerStyle = {
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#fff',
  }

  const largeSidebarStyle = {
    width: '15rem',
    backgroundColor: '#f8f9fa',
    borderRight: '1px solid #ddd',
    padding: '1rem',
    boxSizing: 'border-box',
  }

  const largeMainStyle = {
    flexGrow: 1,
    padding: '5rem',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  }

  const smallContainerStyle = {
    display: 'block',
    minHeight: '100vh',
    backgroundColor: '#fff',
  }

  const smallSidebarStyle = {
    width: '100%',
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #ddd',
    padding: '1rem',
    boxSizing: 'border-box',
  }

  const smallMainStyle = {
    padding: '2rem',
    backgroundColor: '#fff',
    boxSizing: 'border-box',
  }

  return (
    <div style={isLargeScreen ? largeContainerStyle : smallContainerStyle}>
      <aside style={isLargeScreen ? largeSidebarStyle : smallSidebarStyle}>
        <SidebarPage />
        {username && (
          <p style={{ marginTop: '1rem', fontWeight: 'bold' }}>
            Welcome, {username}
          </p>
        )}
      </aside>

      <main style={isLargeScreen ? largeMainStyle : smallMainStyle}>
        <DeveloperPageProfilepage/>
      </main>
    </div>
  )
}
